<template>
  <div class="manual-payments">
    <breadcrumbs :breadcrumbsData="breadcrumbsData" />
    <div class="filters">
      <div class="search">
        <div class="option" ref="marketplaceRef">
          <span>Marketplace</span>
          <artmisads-select :clearable="true" style="width: 232px" v-model:value="filters.marketplace"
            :getPopupContainer="() => $refs.marketplaceRef">
            <template v-for="option in COUNTRY_BASE" :key="option.countryCode">
              <a-select-option class="country-select-item" :value="option.host">
                <Icon :name="option.icon"></Icon>
                <span>{{ option.host }}</span>
              </a-select-option>
            </template>
          </artmisads-select>
        </div>
        <div class="option">
          <span>Publisher</span>
          <artmisads-select show-search v-model:value="filters.publisherId" style="width: 232px"
            :options="publisherOptions" @search="searchPublisher" :show-arrow="false" :filter-option="false"
            :not-found-content="null" placeholder="All" allowClear />
        </div>
        <div class="option">
          <span>BD</span>
          <artmisads-input v-model:value="filters.bd" placeholder="Enter BD" style="width: 232px" />
        </div>
        <div class="option">
          <span>Referral</span>
          <artmisads-input v-model:value="filters.referral" placeholder="Enter Referral" style="width: 232px" />
        </div>

      </div>

    </div>
    <div class="option buttons">

      <artmisads-button isSquare="true" type="primary" style="margin-right: 12px" :loading="load"
        @click="searchList">Search</artmisads-button>
      <artmisads-button isSquare="true" @click="onReset">Reset</artmisads-button>
      <artmisads-button isSquare="true" type="primary" style="margin-left: 12px" @click="exportData">
        Export
      </artmisads-button>
    </div>
    <div class="table-data">
      <artmisads-table v-model:pagination="pagination" :columns="columns" :data-source="dataList"
        :change="onTableChange" :loading="load" :scroll="{ x: 1600, y: tableScrollHeight }">
       <template #bodyCell="{ column, record, text }">
        <template v-if="column.name === 'showCurrency'">
          {{AMAZON_CURRENCY_MAPPER[record.marketplace]}}{{text}}
       </template>
       </template>
      </artmisads-table>
    </div>

  </div>
</template>

<script setup>
import { ref, reactive, onMounted, watch } from 'vue'
import breadcrumbs from '@/components/breadcrumbs.vue'
import { COUNTRY_BASE } from '~/contants/common'
import { useTableScrollHeight } from '@/utils/useTableScrollHeight'
import { financeApi } from '~/server/operator/finance'
import moment from 'moment'
import { useUserInfoStore } from '@/storeData'
import Icon from "@/components/Icon.vue"
import { publisherAdminApi } from '~/server/index'

  // import { AMAZON_CURRENCY_MAPPER, BILLING_TIME_TZ } from '~/contants/common';

import { CURRENCY_MAPPER, COUNTRY_SITE_CODE_MAP,AMAZON_CURRENCY_MAPPER } from '~/contants/common'
const columns = [
  {
    title: 'Publisher',
    dataIndex: 'publisherName',
    key: 'publisherName',
    align: 'center',
  },
  // {
  //   title: 'Lifetime Earnings',
  //   dataIndex: 'totalLifetimeEarnings',
  //   key: 'totalLifetimeEarnings',
  //   align: 'center',
  //    name: 'showCurrency',
  // },
  {
    title: 'Settled Earnings',
    dataIndex: 'totalSettledEarnings',
    key: 'totalSettledEarnings',
    align: 'center',
     name: 'showCurrency',
  },
  {
    title: 'Seller Pending To Pay',
    dataIndex: 'totalAwaitingBrandPayment',
    key: 'totalAwaitingBrandPayment',
    align: 'center',
     name: 'showCurrency',
  },
  {
    title: 'Ready To Pay Publisher',
    dataIndex: 'totalScheduledPayment',
    key: 'totalScheduledPayment',
    align: 'center',
     name: 'showCurrency',
  },
  {
    title: 'Paid To Publisher',
    dataIndex: 'totalCommissionPaid',
    key: 'totalCommissionPaid',
    align: 'center',
     name: 'showCurrency',
  },
  {
    title: 'BD',
    dataIndex: 'bd',
    key: 'bd',
    align: 'center',
  },
  {
    title: 'Referral',
    dataIndex: 'referral',
    key: 'referral',
    align: 'center',
  },
]
const publisherOptions = ref([])
const user = useUserInfoStore()
const countryCode = user?.userInfo?.countryCode || 'US'
const marketplace = CURRENCY_MAPPER[countryCode].host
const dataList = ref([])
const modelRef = ref(null)
const pagination = reactive({
  current: 1,
  defaultPageSize: 10,
  size: 10,
  pageSize: 10,
  total: 0,
  pageSizeOptions: ['10', '20', '50', '100'],
  showSizeChanger: true,
})
const marketplaceRef = ref(null)
const COUNTRY_BASE_OPTIONS = COUNTRY_BASE.map((item) => {
  item.value = item.host
  item.label = item.host
  return item
})
const { tableScrollHeight } = useTableScrollHeight({
  selector: '.table-data',
  bottomSpace: 280,
  minHeight: 200,
  maxHeight: 1000,
  defaultHeight: 350,
})
const load = ref(false)
const breadcrumbsData = ref({
  title: 'PublishersPaymentInfo',
  des: '',
  links: [
    {
      name: 'Home',
      path: '/operator/users',
    },
    {
      name: 'Finance',
      path: '/operator/finance/payments',
    },
    {
      name: 'PublishersPaymentInfo',
      path: '/operator/finance/publishersPaymentInfo',
    },
  ],
})
const filters = ref({
  marketplace: 'amazon.com',
  publisher: '',
  bd: '',
  referral: '',
})
const searchPublisher = async keyword => {
  const params = {
    keyword,
    marketplace: filters.value.marketplace
  }
  let data = await publisherAdminApi.searchPublisher(params)
  if (data && data.length) {
    data = data.map(item => {
      item.value = item.id
      item.label = item.creatorName
      return item
    })
    publisherOptions.value = data
  }
}
const searchList = async () => {
  // console.log(filters.value)
  pagination.current = 1
  getData(filters.value)
}
// setTimeout(() => {
//   modelRef.value.show()
// }, 1000);
const bulkUpdateModelRef = ref(null)
const bulkUpdate = () => {
  bulkUpdateModelRef.value.open()
}
const exportData = () => {
  const params = {
    ...filters.value,
    page: pagination.current,
    size: pagination.size,
  }
  if (params.marketplace) {
    params.countryCode = COUNTRY_SITE_CODE_MAP[params.marketplace]
  }
  financeApi.financePublisherPublisherAggExport({
    qs: params,
    fileName: `publishers_payment_info_${moment().format('YYYY-MM-DD')}.csv`,
    platform: 'operator'
  })
}
const addManualPayment = () => {
  modelRef.value.show()
}

const onReset = () => {
  filters.value = {
    marketplace: 'amazon.com',
    publisher: '',
    bd: '',
    referral: '',
  }
  pagination.current = 1
  pagination.size = 10

  getData({})
}
const onTableChange = ({ current, pageSize }) => {
  // console.log(current, pageSize,'数据')
  pagination.current = current
  pagination.size = pageSize
  pagination.pageSize = pageSize
  getData({ page: current, size: pageSize })
}
const getData = async (params) => {
  load.value = true
  if (Object.keys(params).length === 0) {
    pagination.current = 1
  }
  let _params = {
    page: pagination.current,
    size: pagination.size,
    ...filters.value,
  }

  if (_params.marketplace) {
    _params.countryCode = COUNTRY_SITE_CODE_MAP[_params.marketplace]
  }
  let newparams = { ..._params }
  newparams = Object.keys(newparams).reduce((acc, key) => {
    if (
      newparams[key] !== null &&
      newparams[key] !== undefined &&
      newparams[key] !== ''
    ) {
      acc[key] = newparams[key]
    }
    return acc
  }, {})
  financeApi
    .financePublisherAgg(newparams)
    .then((res) => {

      if (res.success) {
        dataList.value = res.data.data
        pagination.total = res.data.total
      }
    })
    .finally(() => {
      load.value = false
    })
}

const edit = (record) => {
  console.log(record, 'record')
}
const view = (record) => {
  console.log(record, 'record')
}
const revoke = (record) => {
  console.log(record, 'record')
}
// getData({})
onMounted(() => {
  getData({})
})
// setTimeout(() => {
//   modelRef.value.show()
// }, 1000);
</script>
<style scoped lang="less">
:deep(.country-select-item) {
  .ant-select-item-option-content {
    display: flex;

    svg {
      align-self: center;
      margin-right: 4px;
    }
  }
}

.autoComplete {
  :deep(.ant-select-selector) {
    height: 32px !important;
  }

  :deep(.ant-select-selection-search-input) {
    height: 32px !important;
  }

  :deep(.ant-select-selection-placeholder) {
    line-height: 32px !important;
  }
}

.manual-payments {
  padding: 16px;
  padding-top: unset;
  width: 100%;
}

.page-title {
  font-size: 24px;
  font-weight: 600;
  margin: 16px 0;
  color: var(--dark-1);
}

.table-data {

  border-radius: 8px;
  border: 1px solid #fff;
  border-radius: 12px;
  overflow: hidden;
  border-radius: 12px;
  background-color: var(--color-white);
  padding: 15px;

  :deep(.ant-table) {
    border-radius: 8px 8px 0 0;
  }

  :deep(.ant-table-cell) {
    padding-left: 8px;
    padding-right: 8px;

    >a {
      color: var(--primary);

      &:hover {
        color: var(--primary-hover);
      }
    }
  }

  :deep(.ant-table-thead) {
    border-radius: 8px 8px 0 0;
  }

  .user {
    flex: 1;

    .user-name {
      color: var(--dark-1);
      font-weight: 500;
      font-size: 16px;
      letter-spacing: 0.4px;
      line-height: 20px;

      >span {
        font-weight: 400;
        margin-left: 4px;
      }
    }

    .user-email {
      font-weight: 500;
      font-size: 12px;
      color: var(--dark-2);
      letter-spacing: 0.3px;
      line-height: 16px;
      padding: 10px 0;
    }

    .user-id {
      height: 16px;
      font-weight: 500;
      font-size: 12px;
      color: var(--dark-3);
      letter-spacing: 0.3px;
      line-height: 16px;
    }
  }

}

.option {
  >span {
    margin-right: 8px;
  }

  justify-content: flex-end;
  // flex-direction: ;
  margin-bottom: 12px;
  display: flex;
  align-items: center;

}

.filters {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;

  .search {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    align-items: center;
    justify-content: space-between;



    .buttons {
      margin-left: 24px;
      gap: 12px;
    }
  }
}
</style>
